

$(document).ready(function () {

  
var config = { attributes: true, childList: true, characterData: true };


$(".custom-file-upload").each(function () {
  var target = this;
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      
     if(!$('input[type="checkbox"]').is(":checked") && $('.custom-file-upload').attr("required") == "required") {
       var fileuploaded = $("#addtocartbutton");
       fileuploaded.addClass("greyedout");
     } else {
       var fileuploaded = $("#addtocartbutton");
       fileuploaded.removeClass("greyedout");
     }
   });
});

  observer.observe(target, config);
});

$(".engravings").each(function () {
  var target = this;
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
    findAndLogOptionVariant(); 
   });
});

  observer.observe(target, config);
});

$('input[name="id"]').each(function () {
  var target = this;
  var config = { attributes: true, childList: true, subtree: true };

  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      findAndLogOptionVariant();
    });
  });

  observer.observe(target, config);
});

$('#pic').each(function () {
  var target = this;
  var config = { attributes: true, childList: true, subtree: true };

  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      updateButtonState();
    });
  });

  observer.observe(target, config);
});
  
$(".cart-display").each(function () {
  var target = this;
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      
      var getimg = $('.image-link');
             $('.image-link').magnificPopup({
                callbacks: {
                open: function(){
                   $('[data-href="#cart-notification"]').attr("imgshow","true");
                },
                close: function (){
                  setTimeout(function(){
                   $('[data-href="#cart-notification"]').attr("imgshow","false");  
                                       }, 100);
                }
            },
    type:'image'});


      
    });
  });

  observer.observe(target, config);
});




$(document).on("click", ".preview", function() {
//Slide back on button click


$('html, body').animate({ scrollTop: 0 }, 'smooth');


const sliderContainer = document.querySelector('.image-slider-inside');

// Check if the slider container element was found
if (sliderContainer) {
  // Reset the scroll position to 0 (start of the slider) with smooth scrolling
  sliderContainer.scrollTo({
    left: 0,
    behavior: 'smooth'
  });
  }  
});


// ======================= Use this code only its work for both home collection product and search =======================

// if you trigger another code for collection with the condition of template then it does not work as expected on  search and home page



// ===========================================  

//PRODUCT RECOMMENDATIONS
//PRODUCT RECOMMENDATIONS



  
  //BACK TO TOP JAVASCRIPT START
  $(window).scroll(function () {
    if ($(this).scrollTop() > 500) {
      $('#slidetop').fadeIn(500);
    } else {
      $('#slidetop').fadeOut(500);
    }
  });
  $('#slidetop').click(function (e) {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: 0
    }, 800);
  });
  //BACK TO TOP JAVASCRIPT END
  
  //DISABLED ZOOM FOR VIDEO JAVASCRIPT START
  $(".product__media-item").click(function(){
    if($(this).attr("data-media-type") == 'video'){
      $('.zoomContainer').hide();
    }else{
      $('.zoomContainer').show();
    }
  });
   //DISABLED ZOOM FOR VIDEO JAVASCRIPT END
  
  //DEFAULT COLLAPSE JAVASCRIPT START
  $(document).on("click","[data-toggle='collapse']",function() {
    var parent = $(this).data("parent");
    var target = $(this).data("href");
    if($(parent).length && $(parent).hasClass('panel-group')) {
     $(parent+" .panel").each(function() {
       var p = $(this).find("[data-toggle='collapse']");
       var t = p.data("href");
       if(t!= target && p.attr("aria-expanded") == "true") {
        $(t).slideUp().removeClass("in");
        p.addClass("ishi-collapsed").attr("aria-expanded","false");
       } 
     });
    } 
    if($(this).attr("aria-expanded") == "false") {
      $(target).slideDown().addClass("in");
      $(this).removeClass("ishi-collapsed").attr("aria-expanded","true");
    } else {
      $(target).slideUp().removeClass("in");
      $(this).addClass("ishi-collapsed").attr("aria-expanded","false");
    }
  });
  //DEFAULT COLLAPSE JAVASCRIPT END
  
  //DEFAULT POPOVER JAVASCRIPT START
  $(document).on("click","[data-toggle='popover']",function() {
    var target = $(this).data("href");

    // Check if the element has the "loading" class
    if (!$(this).hasClass("loading")) {
        // If not, add the "loading" class
        $(this).addClass("loading");
    } else {
        $(this).removeClass("loading");
    }
    
    if($(this).attr("aria-expanded") == "false") {
      $(target).addClass("active");
      $(this).attr("aria-expanded","true");
    } else {
      $(target).removeClass("active");
      $(this).attr("aria-expanded","false");
    }
  });
  $(document).on("click", function(event){
    if(!$(event.target).closest('#search-container-full').length && !$(event.target).closest('[data-href="#search-container-full"]').length){
      if($('[data-href="#search-container-full"]').attr("aria-expanded") == "true") {
        $("#search-container-full").removeClass("active");
        $('[data-href="#search-container-full"]').attr("aria-expanded","false");
      }
    }
    
    if(!$(event.target).closest('#user-notification').length && !$(event.target).closest('[data-href="#user-notification"]').length){
      if($('[data-href="#user-notification"]').attr("aria-expanded") == "true") {
        $("#user-notification").removeClass("active");
        $('[data-href="#user-notification"]').attr("aria-expanded","false");
        event.preventDefault();
      }
    }


    if(!$(event.target).closest('#cart-notification').length && !$(event.target).closest('[data-href="#cart-notification"]').length){
      if($('[data-href="#cart-notification"]').attr("aria-expanded") == "true" && $('[data-href="#cart-notification"]').attr("imgshow") == "false") {
        $("#cart-notification").removeClass("active");
        $('.holder').removeClass("active");
        //$('.mobile-menu-overlay3').removeClass("active");
        $('.closecart').removeClass("active");
        $('[id="cart-notification-default"]').removeClass("active");
        $('.goal').removeClass("active");
        $('.item-upsell-desktop').removeClass("active");
        $('.progress-wrapper').removeClass("active");
        $('.shippingdetails').removeClass("active");
        $('#cart-notification-checkout').removeClass("active");
        $('.cart-notification__header').removeClass("active");
        $('.cart-footer').removeClass("active");
        $('.cart-footer2').removeClass("active");
        $('.free-shipping').removeClass("active");
        $('.alert-nosuccess').removeClass("active");
        $('.alert-success').removeClass("active");
        $('[data-href="#cart-notification"]').attr("aria-expanded","false");
        
        if (!document.querySelector('.toggle-dropdown1').classList.contains('active')) {
            enableScroll(); // Trigger enableScroll() function
        }

      }
    }
    
    if(!$(event.target).closest('#HeaderCountryList').length && !$(event.target).closest('[data-href="#HeaderCountryList"]').length){
      if($('[data-href="#HeaderCountryList"]').attr("aria-expanded") == "true") {
        $("#HeaderCountryList").removeClass("active");
        $('[data-href="#HeaderCountryList"]').attr("aria-expanded","false");
      }
    }
    
    if(!$(event.target).closest('#HeaderLanguageList').length && !$(event.target).closest('[data-href="#HeaderLanguageList"]').length){
      if($('[data-href="#HeaderLanguageList"]').attr("aria-expanded") == "true") {
        $("#HeaderLanguageList").removeClass("active");
        $('[data-href="#HeaderLanguageList"]').attr("aria-expanded","false");
      }
    }
    
  });
  //DEFAULT POPOVER JAVASCRIPT END
  
  //DEFAULT TABS JAVASCRIPT START
  $(document).on("click",".ishi-nav-link",function() {
    $(this).parents(".ishi-nav-tabs").find(".ishi-tab-item").removeClass("active");
    $(this).parents(".ishi-tab-item").addClass("active");
    
    $(this).parents(".ishi-product-tab").find(".ishi-tab-pane").removeClass("active");
    var target = $(this).data("href");
    $(target).addClass("active");
  });
  //DEFAULT TABS JAVASCRIPT END
  
  //DEFAULT PANEL JAVASCRIPT START
  $(document).on("click",'[data-action="ishi-panel"]',function() {
    var target = $(this).attr("aria-controls");
    $(this).parents(".ishi-panel-container").find(".ishi-panel-data").removeClass("active");
    $(target).addClass("active");
  });
  //DEFAULT PANEL JAVASCRIPT END





  


function createPopup(className, message) {

    // Find the first .popup element and remove the 'active' class
    const existingPopup = document.querySelector('.popup.active');
    if (existingPopup) {
        existingPopup.classList.remove('active');
        existingPopup.classList.add('remove');
    }
  
    // Get the container with the ID "popup-container"
    const container = document.getElementById('popup-container');

    // Create a new div element with the specified class and message
    const newPopup = document.createElement('div');
    newPopup.className = `${className} popup`; // Without 'active' class initially
    newPopup.innerHTML = message;

    // Append the new div element to the container
    container.appendChild(newPopup);

    // Force a reflow to apply the initial styles
    newPopup.style.opacity; // This line triggers a reflow

    // Add the 'active' class with a delay to trigger the transition
    setTimeout(() => {
        newPopup.classList.add('active');
    }, 3);

    // Automatically remove the new div element after a certain time (e.g., 3 seconds)
    setTimeout(() => {
        newPopup.remove();
    }, 2000); // Adjust the time as needed
}













  
//Check for wishlist amount
  
var str = getTheCookie("wishlist");
if (str) {
  // Regular expression to match items starting with "__" and ending with a random string
  var regex = /__[^__]+/g;
  var matches = str.match(regex);

  if (matches) {
    var uniqueItems = [...new Set(matches)]; // Remove duplicates

    // Update the element with class "wishlist-amount"
    var wishlistAmountElement = $(".wishlist-amount");
    if (wishlistAmountElement.length) {
      wishlistAmountElement.html(uniqueItems.length);
    }
  }
}


  

if ($(".add-in-wishlist-js").length != 0) {
  $(document).on("click", ".add-in-wishlist-js", function (event) {
    event.preventDefault();
    if ($(this).hasClass("added-wishlist")) return true;
    event.preventDefault();
    try {
      var id = $(this).data('href');
      if (getTheCookie("wishlist") == null) {
        var str = '__' + id;
      } else {
        if (getTheCookie("wishlist").indexOf(id) == -1) {
          var str = getTheCookie("wishlist") + '__' + id;
        }
      }
      setTheCookie("wishlist", str, 14);
      $('.default-wishbutton-' + id).hide();
      $('.added-wishbutton-' + id).show();
      countDifferentItemsInWishlist(); // Add this line to count items

      var wishlistScript = document.getElementById('wishlistMessages');
      var wishlistMessages = JSON.parse(wishlistScript.textContent);
      
      // Now you can use wishlistMessages object as needed
      // For example:
      var addedwishlistMessage = wishlistMessages.addedwishlist;
            
      var addedwishlistPopup = createPopup('wishlist-add', addedwishlistMessage);
   
    } catch (err) {
      //
    }
  });
}

$(document).on("click", ".remove-wishlist", function (event) {
  event.preventDefault();
  var item = $(this).data('href');
  var str = getTheCookie("wishlist");
  var removeitem = str.replace(new RegExp("__" + item, "g"), "");
  setTheCookie("wishlist", removeitem);
  $('.default-wishbutton-' + item).show();
  $('.added-wishbutton-' + item).hide();
  var wishlistScript = document.getElementById('wishlistMessages');
  var wishlistMessages = JSON.parse(wishlistScript.textContent);
  
  // Now you can use wishlistMessages object as needed
  // For example:
  var removedwishlistMessage = wishlistMessages.removedwishlist;
        
  var removedwishlistPopup = createPopup('wishlist-remove', removedwishlistMessage);

  // Regular expression to match items starting with "__" and ending with a random string
  var regex = /__[^__]+/g;
  var matches = removeitem.match(regex);

  if (matches) {
    var uniqueItems = [...new Set(matches)]; // Remove duplicates

    // Update the element with class "wishlist-amount"
    var wishlistAmountElement = $(".wishlist-amount");
    if (wishlistAmountElement.length) {
      wishlistAmountElement.html(uniqueItems.length);
    }
  } else {

    // Update the element with class "wishlist-amount" if there are no items left
    var wishlistAmountElement = $(".wishlist-amount");
    if (wishlistAmountElement.length) {
      wishlistAmountElement.html("0");
    }
  }

  function hasOnlySpecialCharacter(val) {
    var pattern = /^[^a-zA-Z0-9]+$/;
    return pattern.test(val);
  }

  if (hasOnlySpecialCharacter(removeitem)) {
    removeitem = "";
    setTheCookie("wishlist", removeitem);
  }
});


function countDifferentItemsInWishlist() {
  var wishlistStr = getTheCookie("wishlist");
  if (wishlistStr) {
    // Regular expression to match items starting with "__" and ending with a random string
    var regex = /__[^__]+/g;
    var matches = wishlistStr.match(regex);

    if (matches) {
      var uniqueItems = [...new Set(matches)]; // Remove duplicates

      // Update the element with class "wishlist-amount"
      var wishlistAmountElement = $(".wishlist-amount");
      if (wishlistAmountElement.length) {
        wishlistAmountElement.html(uniqueItems.length);
      }
    }
  }
}

setupWishlistButtons();
//DEFAULT WISHLIST JS END


//Updated2
  

  
//Start slick;

  //CART PAGE EDIT BUTTON JAVASCRIPT START
  $(document).on("click",".js-edit-toggle",function() {
    $(this).parents("tr").toggleClass("cart__update--show");
    $(this).toggleClass("cart__edit--active");
  });
  //CART PAGE EDIT BUTTON JAVASCRIPT END
  
  //STOCK URGENCY START
      var stock = parseInt($("#variant-stock").html());
      var maxqty = parseInt($(".selected-variant").data("quantity"));
      if(stock == '' || stock <= 0) {
        $(".ishi-progress-content").addClass('hidden');
      }
      switch(stock){case 9:$("#ishi-progress-bar span").css("width","65%");break;case 8:$("#ishi-progress-bar span").css("width","60%");break;case 7:$("#ishi-progress-bar span").css("width","55%");break;case 6:$("#ishi-progress-bar span").css("width","50%");break;case 5:$("#ishi-progress-bar span").css("width","40%");break;case 4:$("#ishi-progress-bar span").css("width","30%");break;case 3:$("#ishi-progress-bar span").css("width","20%");break;case 2:$("#ishi-progress-bar span").css("width","10%");break;case 1:$("#ishi-progress-bar span").css("width","5%");break;default:$("#ishi-progress-bar span").css("width","90%")}
  //STOCK URGENCY END
  
  //PRODUCT MEDIA CHANGE ON CLICK JAVASCRIPT START
    $(document).on("click",".product__media-list .product__media-item",function(){
      if($(this).data("media-type") != "model") $('#main-media-container').html($(this).clone());
    });
    if($(".enablezoom").length > 0  ){
      if($("#main-media-container").length && window.matchMedia("(min-width: 991px)").matches){
          $("#main-media-container img").elevateZoom({zoomType: "inner", cursor: "crosshair"});
       }
    $(document).on("DOMSubtreeModified", "#main-media-container",function() {
      if(window.matchMedia("(min-width: 991px)").matches && $(this).find(".product__media-item").data("media-type") != "video") {
         $("#main-media-container img").elevateZoom({zoomType: "inner", cursor: "crosshair"});
      }
    }); 
    } 
  //PRODUCT MEDIA CHANGE ON CLICK JAVASCRIPT END
  
  //PRODUCT THUMBNAILS SLIDER INITIALIZE JAVASCRIPT START
  $('.product__media-list').owlCarousel({
    nav: true,
    navText: [
      '<i class=\'fa fa-angle-left\'></i>',
      '<i class=\'fa fa-angle-right\'></i>'
    ],
    dots: false,
    loop: false,
    margin:15,
    rewind:true,
    responsive: {
      0: {
        items: 3
      },
      544: {
        items: 4
      },
      768: {
        items: 3
      },
      992: {
        items: $('#shopify-section-Ishi_sidebar').length ? 3 : 4
      },
      1200: {
        items: 4
      }
    }
  });
  //PRODUCT THUMBNAILS SLIDER INITIALIZE JAVASCRIPT END
  
  //COLLECTION GRID-LIST JAVASCRIPT START
  $(document).on("click",".collectiongrid-layout",function() {
    var id = $(this).data("id");
    setTheCookie("collectiongrid-layout", id, 14);
    setGridLayout();
  });
  setGridLayout();
  //COLLECTION GRID-LIST JAVASCRIPT END
  
  
  //CART BUTTONS SCRIPT START
  $(document).on("click","#qv-add-to-cart",function(){
    if($(this).hasClass("sold-out")) return false;
    var variantId = $("#qv-variantid").val();
    var qty = $("#qv-quantity-selector input").val();
    $(this).addClass("loading");
    addToCartJS(qty, variantId, this);
  });

  $(document).on("click", "#qv-customize", function () {
      var $this = $(this);
  
      // Add the "loading" class
      $this.addClass("loading");
  
      // Remove the "loading" class after 1000 milliseconds (1 second)
      setTimeout(function () {
          $this.removeClass("loading");
      }, 500);
  });

    
  $(document).on("click",".cart-remove-js",function() {
  	var variantID = this.getAttribute("data-variantid");
    removeFromCartJS(variantID);
  });




  $(document).on("click", ".cart-button", function () {
      var variantID = this.getAttribute("atc-id");
      qty = 1;
      // Add a 1-second delay before changing the strokeDashoffset
      addToCartJSUpsell(qty, variantID, this);
  });
  
 $(document).on("click", ".cart-plus", function () {
    var variantID = this.getAttribute("data-variantid");
    var currentQuantity = this.getAttribute("quantity");
    var newQuantity = ++currentQuantity;
    IncreaseMyCart(variantID, newQuantity);
  });  
  

  $(document).on("click",".cart-deduct",function() {
  	var variantID = this.getAttribute("data-variantid");
  	var quantity = this.getAttribute("quantity") - 1;
    DecreaseMyCart(variantID,quantity);
  });  
  
  //CART BUTTONS SCRIPT END
  
  //QUICKVIEW SCRIPT START
  $(document).on("click",".quick-view",function() {
    var handle = $(this).data("handle");
        // Find elements with class "alert-nosuccess" and set display: block
    var alertNosuccessElements = document.querySelectorAll('.alert-nosuccess1');
    alertNosuccessElements.forEach(function (element) {
      element.style.display = 'none';
    });
    loadQuickView(handle, $(this));
  });


  $(document).on("click",".localization-opener",function() {
    var localization = document.querySelector(".localization-open");
    localization.classList.add("active");
  });

  
  //QUICKVIEW SCRIPT END
  
  //SIDEBAR FILTERS SCRIPT START 
  if($("#FacetFiltersFormSidebar [type='checkbox']:checked").length) {
    $("#FacetFiltersFormSidebar .clear-all").css("display","inline-block");
  }
//   $(document).on('change',"#SortBy", function() {
//     $("#FacetFiltersFormSidebar [type='checkbox']:checked").each(function( index ) {
//       $(this).parents("label").trigger("click");
//     });
//   }); 
  //SIDEBAR FILTERS SCRIPT END 
  
  // INITIALIZE JS START
  $( ".owl-carousel.slider-with-options" ).each(function( index ) {
    $(this).owlCarousel({
      lazyLoad:true,
      navText: [
        '<i class=\'fa fa-angle-left\'></i>',
      	'<i class=\'fa fa-angle-right\'></i>'
      ],
      loop:($(this).data("loop")) ? true :false,
      rewind: ($(this).data("rewind")) ? true :false,
      nav:($(this).data("nav")) ? true :false,
      center:($(this).data("center")) ? true :false,
      rewind: ($(this).data("rewind")) ? true :false,
      autoplay:($(this).data("autoplay")) ? true :false,
      dots:($(this).data("dots")) ? true :false,
      autoplayTimeout:($(this).data("autoplaytimeout")) ? $(this).data("autoplaytimeout") :4000,
      smartSpeed: ($(this).data("smartspeed")) ? $(this).data("smartspeed") :500,
      margin:($(this).data("margin")) ? $(this).data("margin") : 0,
      responsive: {
        0: {
          items: $(this).data("small")
        },
        544: {
          items: $(this).data("mobile")
        },
        768: {
          items: $(this).data("tablet")
        },
        992: {
          items: $(this).data("laptop")
        },
        1200: {
          items: $(this).data("desktop")
        }
      }
    });
  });
  // INITIALIZE JS END
  
  //COUNTDOWN TIMER START
  $('[data-deal="1"]').each(function( index ) {
    setCountDownTimer($(this).data("counter"), this.querySelector(".countdowncontainer"));
  });
  //COUNTDOWN TIMER END
  
  //WRITE COMMENT JS START
  $(".write_comment").click(function(e) {
    $('.ishi-product-tab .ishi-nav-tabs a.review-tab').trigger('click');
    $('html, body').animate({scrollTop: $(".ishi-product-tab").offset().top - 50}, 2000);
  });
  //WRITE COMMENT JS END
  
  //fixed header
  //adjustFixedHeader();
  //$(window).scroll(function(){
  // adjustFixedHeader();
  //});
  
  var shopify_responsive_current_width = window.innerWidth;
  var shopify_responsive_min_width = 1200;
  var shopify_responsive_mobile = shopify_responsive_current_width < shopify_responsive_min_width;

  if (shopify_responsive_mobile) {
    convertToMobile();
  }

  $(window).on('resize', function () {
    var _mw = shopify_responsive_min_width;
    var _w = window.innerWidth;
    var desktopContent = $("*[id^='_desktop_']").first().html().trim().length;
    var mobileContent = $("*[id^='_mobile_']").first().html().trim().length;
    if(_w < _mw && desktopContent) {
      convertToMobile();
    } 
    if(_w >= _mw && mobileContent) {
      convertToDesktop();
    } 
  });
  
  $('#menu-icon').on('click', function() {
    disableScroll();
    $("#mobile_top_menu_wrapper #_mobile_top_menu").toggleClass("active");
    $('.header__localization').toggleClass("active");
    $("#mobile_top_menu_wrapper #top_menu_closer").toggleClass("active");
    $("#mobile_top_menu_wrapper").toggleClass("active");
    $('.mobile-menu-overlay').toggleClass("active");
  });
  $('#top_menu_closer svg').on('click', function() {
    enableScroll();
    $("#mobile_top_menu_wrapper #_mobile_top_menu").toggleClass("active");
    $('.header__localization').toggleClass("active");
    $("#mobile_top_menu_wrapper #top_menu_closer").toggleClass("active");
    $("#mobile_top_menu_wrapper").toggleClass("active");
    $('.mobile-menu-overlay').toggleClass("active");
  });







  
  $('#top_menu_closer_guide svg').on('click', function() {
    enableScroll();
    $("#mobile_top_menu_wrapper_guide").toggleClass("active");
    $('.mobile-menu-overlay2').toggleClass("active");
  });
  
  $('.mobile-menu-overlay').on('click', function() {
    enableScroll();
    $("#mobile_top_menu_wrapper #_mobile_top_menu").toggleClass("active");
    $('.header__localization').toggleClass("active");
    $("#mobile_top_menu_wrapper #top_menu_closer").toggleClass("active");
    $("#mobile_top_menu_wrapper").toggleClass("active");
    $('.mobile-menu-overlay').toggleClass("active");
  });




  
  //CART 
  $('.cart-display').on('click', function() {


    //No scroll
    disableScroll();
    
    $('.toggle-dropdown1').addClass("active");
    $('.holder').addClass("active");
    $('.closecart').addClass("active");
    $('.mobile-menu-overlay3').addClass("active");
    $('[id="cart-notification-default"]').addClass("active");
    $('.featurescontent2').addClass("active");
    $('.goal').addClass("active");
    $('.item-upsell-desktop').addClass("active");
    $('.progress-wrapper').addClass("active");
    $('.shippingdetails').addClass("active");
    $('#cart-notification-checkout').addClass("active");
    $('.cart-notification__header').addClass("active");
    $('.cart-footer').addClass("active");
    $('.cart-footer2').addClass("active");
    $('.free-shipping').addClass("active");
    $('.alert-nosuccess').addClass("active");
    $('.alert-success').addClass("active");
  });

  $('.closecart div').on('click', function() {
    $('.toggle-dropdown1').removeClass("active");
    $('.holder').removeClass("active");
    $('.closecart').removeClass("active");
    $('.mobile-menu-overlay3').removeClass("active");
    $('[id="cart-notification-default"]').removeClass("active");
    $('.featurescontent2').removeClass("active");
    $('.goal').removeClass("active");
    $('.item-upsell-desktop').removeClass("active");
    $('.progress-wrapper').removeClass("active");
    $('.shippingdetails').removeClass("active");
    $('#cart-notification-checkout').removeClass("active");
    $('.cart-notification__header').removeClass("active");
    $('.cart-footer').removeClass("active");
    $('.cart-footer2').removeClass("active");
    $('.free-shipping').removeClass("active");
    $('.alert-nosuccess').removeClass("active");
    $('.alert-success').removeClass("active");
    $('[data-href="#cart-notification"]').attr("aria-expanded","false");

    enableScroll();

});

  
  $('#imagediv .guideimg').on('click', function() {
    
    disableScroll();
    
    $("#mobile_top_menu_wrapper_guide").toggleClass("active");
    
    $('.mobile-menu-overlay2').toggleClass("active");
  });
  

  $('.mobile-menu-overlay2').on('click', function() {
    enableScroll();
    $("#mobile_top_menu_wrapper_guide").toggleClass("active");
    $('.mobile-menu-overlay2').toggleClass("active");
  });
});


//ISHI FUNCTIONS START

function convertToMobile(){
  //interchange sections

  $("*[id^='_desktop_']").each(function(index, element) {
    var target = $('#' + element.id.replace('_desktop_', '_mobile_'));
    swapElements($(this), target);
  });
}
function convertToDesktop() {
  //interchange sections

  $("*[id^='_mobile_']").each(function(index, element) {
    var target = $('#' + element.id.replace('_mobile_', '_desktop_'));
    swapElements($(this), target);
  });
  if($(".enablezoom").length > 0  ){
    $("#main-media-container").length ? $("#main-media-container img").elevateZoom({zoomType: "inner", cursor: "crosshair"}): "";
  }
}

function swapElements(source, destination) {
  var temp = destination.children().detach();
  destination.empty().append(source.children().detach());
  source.append(temp);
}


if (window.innerWidth < 768) {
  var $originalATC = $('#addtocartbutton'); // Target the original Add to Cart button
  var $mobileATC = $('#mobile-fixed-atc-wrapper');

  if ($originalATC.length) {
    $(window).on('scroll', function () {
      var windowTop = $(window).scrollTop();
      var buttonBottom = $originalATC.offset().top + $originalATC.outerHeight();

      // Show sticky ATC only after you've scrolled past the original button
      if (windowTop > buttonBottom) {
        $mobileATC.fadeIn();
      } else {
        $mobileATC.fadeOut();
      }
    });
  }
}









$(function() {
  // Current Ajax request.
  var currentAjaxRequest = null;


  
  // Grabbing all search forms on the page, and adding a .search-results list to each.
  var searchForms = $('form[action*="search"]').css('position','relative').each(function() {
  // Grabbing text input.
  var input = $(this).find('input[name="q"]');
  // Adding a list for showing search results.
  var offSet = input.position().top + input.innerHeight();
  $('<ul class="search-results"></ul>').css({ 'position': 'absolute', 'left': '0px', 'top': offSet }).appendTo($(this)).hide();    

  // Listening to keyup and change on the text field within these search forms.
  input.attr('autocomplete', 'off').bind('keyup change', function() {
    // What's the search term?
    var term = $(this).val();
    // What's the search form?
    var form = $(this).closest('form');
    // What's the search URL?
    var searchURL = determineSearchURL(term);


    // What's the search results list?
    var resultsList = form.find('.search-results');

    // If the term is not empty and has changed
    if (term.length > 1 && term != $(this).attr('data-old-term')) {
      // Saving old query.
      $(this).attr('data-old-term', term);

      // Killing any Ajax request that's currently being processed.
      if (currentAjaxRequest != null) currentAjaxRequest.abort();

      
      // Pulling results.
      currentAjaxRequest = $.getJSON(searchURL + '&view=json', function(data) {
        // Reset results.
        resultsList.empty();

        // If we have no results.
        if (data.results_count == 0) {
          // Hide the results list if there are no results
          resultsList.hide();
        } else {
          // Limit results to 3 items
          var resultsToShow = data.results.slice(0, 3);
          
          $.each(resultsToShow, function(index, item) {
            var link = $('<a></a>').attr('href', item.url);
            link.append('<span class="thumbnail"><img src="' + item.thumbnail + '" /></span>');
            link.append('<span class="type">' + item.type + '</span>');
            link.append('<span class="title">' + item.title + '</span>');
            link.append('<span class="price">' + item.price + '</span>');
            link.wrap('<li></li>');
            resultsList.append(link.parent());
          });

          // The Ajax request will return at the most 3 results.
          // If there are more than 3, let's link to the search results page.
          if (data.results_count > 3) {
            resultsList.append('<li><a href="' + searchURL + '"><span class="title">' + viewAllResultsText + ' (' + data.results_count + ')</span></a></li>');
          }

          resultsList.fadeIn(200);
        }
      });
    } else {
  // Check if the input term is empty
  if (term.length === 0) {
    // Hide the results list if the term is empty
    resultsList.empty().hide();
    // Clear the old term if search term is empty
    $(this).attr('data-old-term', '');
  } else {
    // If the term hasn't changed but is not empty, do not hide the list
    console.log('Search term is unchanged, keeping the results list visible.');
  }
}
  });
});


  // Function to determine the search URL based on the current window path.
  function determineSearchURL(term) {

    var currentPath = window.location.pathname;
    var baseSearchURL = 'search?type=product&q=';

      return window.Shopify.routes.root + baseSearchURL + term;
  }
  
  // Clicking outside makes the results disappear.
  $('body').bind('click', function(){
    $('.search-results').hide();
  });
});




var variantAvailability = [];
var variantFeaturedImg = [];
var variantFeaturedImgId = [];
var variantIndexIdMapping = [];
var ProductName = [];
var ProductUrl = [];
var ProductTags = [];
var currentVariants = {};
var availableVariants = [];
var variantCompareAtPrice = [];
var variantPrice = [];
var myImages = [];
var myVar;

function determineSearchURL(term) {
  return `${window.Shopify.routes.root}search?type=product&q=${term}`;
}

function decodeHtmlEntities(text) {
  const parser = new DOMParser();
  const decodedHtml = parser.parseFromString(text, 'text/html');
  return decodedHtml.body.textContent;
}

function replaceVideoPlaceholder(videoData, placeholderAlt) {
  if (videoData == null) return;
  document.querySelectorAll(`[alt="${placeholderAlt}"]`).forEach(element => {
    const decodedContent = decodeHtmlEntities(videoData);
    const replacementElement = document.createElement('div');
    replacementElement.innerHTML = decodedContent;
    element.parentNode?.replaceChild(replacementElement, element);
  });
}

function fetchAndProcessQuickviewData(handle, callbackAfterData) {
  const searchURL = determineSearchURL(handle);
  $.getJSON(`${searchURL}&view=json`, function(data) {
    const variantsHideMe = document.getElementById("variants-hide-me");
    if (variantsHideMe) variantsHideMe.innerHTML = "";

    if (data.results && variantsHideMe) {
      $.each(data.results, function(index, item) {
        if (!item.quickview) return;
        $.each(item.quickview, function(qIndex, qItem) {
          const option = document.createElement("option");
          option.setAttribute("data-image-positions", qItem.variant);
          option.setAttribute("stock", qItem.stock);
          option.innerText = qItem.position;
          variantsHideMe.appendChild(option);

          replaceVideoPlaceholder(qItem.videogold1, 'vid-gold1');
          replaceVideoPlaceholder(qItem.videogold2, 'vid-gold2');
          replaceVideoPlaceholder(qItem.videogold3, 'vid-gold3');
          $(`[image-position-quickview="${qItem.variant}"]`).attr('image-position-quickview', qItem.position);
        });
      });
    }
    if (callbackAfterData && typeof callbackAfterData === 'function') {
      callbackAfterData();
    }
  });
}

function setProductInformation(product, handle) {
  ProductName = [product.title];
  ProductUrl = [product.url];
  ProductTags = [product.tags];

  $("#qv-productname").html(product.title).attr("data-product-id", product.id);
  $("#qv-productdescription").html(product.description);
  $(".more-description").css("display", product.description.length < 600 ? "none" : "block");
  $("#qv-product-cover img").attr("src", product.featured_image);

  const reviewsBadge = $(`[data-handle="${handle}"]`).closest(".card-wrapper").find(".spr-badge");
  $("#qv-spr-badge").html(reviewsBadge.length ? reviewsBadge.clone().html() : '');

  const sliderContainer = document.querySelector('.image-slider-inside.quickview .flickity-slider') || document.querySelector('.image-slider-inside.quickview');
  if (sliderContainer) sliderContainer.scrollLeft = 0;

  prepareQvThumbnailss(product.images, product);
  myImages = product.images;
}

function prepareProductDropdowns(productOptions) {
  $(productOptions).each(function(i, option) {
    const name = option.name;
    const selectWrapper = $('<div class="dropdown-wrapper"></div>')
      .append(`<div class="option-label"><label for="select-option${option.position}">${name}</label></div>`);
    const selectBox = $(`<select id="select-option${option.position}" name="options[${name}]" class="select__select"></select>`);

    $(option.values).each((j, value) => {
      selectBox.append(`<option value="${value}" ${j === 0 ? 'selected' : ''}>${value}</option>`);
    });
    selectWrapper.append($('<div class="select"></div>').append(selectBox));
    $("#qv-variants").append(selectWrapper);
  });
}

function processProductVariants(productVariants) {
  [variantIndexIdMapping, availableVariants, variantAvailability, variantFeaturedImg, variantFeaturedImgId, variantCompareAtPrice, variantPrice] = [[], [], [], [], [], [], []];

  $(productVariants).each(function(index, variant) {
    const variantsList = variant.title.split("/");
    const variantsKeyVal = {};
    variantsList.forEach((v, i) => { variantsKeyVal[`select-option${i + 1}`] = v.trim(); });

    variantIndexIdMapping.push(variant.id);
    availableVariants.push(variantsKeyVal);
    variantAvailability.push(variant.available);
    variantFeaturedImg.push(variant.featured_image?.src || null);
    variantFeaturedImgId.push(variant.featured_media?.id || null);
    variantCompareAtPrice.push(variant.compare_at_price);
    variantPrice.push(variant.price);
  });
}

function updateSingleVariantUI(variant) {
  if (!variant) return;
  $("#qv-variantid").val(variant.id);
  $("#qv-add-to-cart").toggleClass("sold-out", !variant.available);

  if (variant.compare_at_price != null && parseFloat(variant.compare_at_price) > parseFloat(variant.price)) {
    $("#qv-compareatprice").html(convertToMoney(variant.compare_at_price));
    $("#qv-price").html(convertToMoney(variant.price));
  } else {
    $("#qv-compareatprice").html('');
    $("#qv-price").html(convertToMoney(variant.price));
  }

  const isProductPersonalized = ProductTags.some(tagsArray =>
    tagsArray.some(tag => typeof tag === 'string' && tag.toLowerCase() === "personalization")
  );
  if (ProductUrl.length > 0) $(".qv-customize-url:first").attr("href", ProductUrl[0]);

  $("#qv-soldout").css("display", !variant.available ? "block" : "none");
  $("#qv-customize").css("display", variant.available && isProductPersonalized ? "flex" : "none");
  $("#qv-add-to-cart").css("display", variant.available && !isProductPersonalized ? "flex" : "none");
  if (!variant.available) $("#qv-add-to-cart").addClass("sold-out"); // Ensure class if not available
}

function prepareQvThumbnailss(images, product) {
  document.querySelectorAll('.images-sl').forEach(el => el.remove());
  const imageSlider = document.querySelector('.image-slider-inside.quickview .flickity-slider') || document.querySelector('.image-slider-inside.quickview');
  if (!imageSlider || !images || images.length === 0) return;

  images.forEach((src, i) => {
    const mediaItem = product.media[i];
    const altText = mediaItem?.alt || product.title || 'Product image';
    const index = i + 1;
    const divElement = document.createElement('div');
    divElement.className = 'images-sl';
    divElement.id = `image-positionquick-${index}`;
    divElement.setAttribute('data-alt', altText);
    divElement.style.display = 'block';

    const screenWidth = window.innerWidth;
    let sizeSuffix = '_350x';
    if (screenWidth >= 1440) sizeSuffix = '_600x';
    else if (screenWidth >= 1080) sizeSuffix = '_400x';
    else if (screenWidth >= 768) sizeSuffix = '_300x';
    else if (screenWidth >= 520) sizeSuffix = '_400x';

    const sizedSrc = src.replace(/(\.[a-z]+)(\?.*)?$/i, `${sizeSuffix}$1$2`);
    divElement.innerHTML = `
      <div aria-hidden="true" style="opacity:1;transition:opacity 500ms linear"></div>
      <picture><img src="${sizedSrc}" alt="${altText}" class="lazyload" id="img${index}"></picture>`;
    imageSlider.appendChild(divElement);
  });
}

function handleizeString(str) {
  if (typeof str !== 'string') return '';
  return str
    .toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/[^\w-]+/g, '') // Remove all non-word chars except hyphens (allows letters, numbers, underscore, hyphen)
    .replace(/--+/g, '-') // Replace multiple hyphens with single
    .replace(/^-+/, '') // Trim leading hyphen
    .replace(/-+$/, ''); // Trim trailing hyphen
}


function loadQuickView(handle, btn) {
  
  [variantAvailability, variantFeaturedImg, variantFeaturedImgId, variantIndexIdMapping, ProductName, ProductUrl, ProductTags, currentVariants, availableVariants, variantCompareAtPrice, variantPrice, myImages] = [[], [], [], [], [], [], [], {}, [], [], [], []];
  $("#qv-variants").html('');
  $("#ModalClose-quick-view").off('click.qvClose').on('click.qvClose', () => {});

  const url = `${window.Shopify.routes.root}products/${handle}.js`;
  jQuery.getJSON(url, function(product) {
    window.myVar = product;
    setProductInformation(product, handle);
    processProductVariants(product.variants);

    const commonUICallbackAfterAjax = () => {
      $('.qv-wrapper, .product-popup-modal__button.link.modalbutton').removeClass('loading');
      if (typeof loadCurrentQvVariants === 'function') loadCurrentQvVariants();
      if (typeof updateQvVariantDetails === 'function') updateQvVariantDetails();
    };

    const hasOptions = product.options?.some(opt => opt.values.length > 1) && product.variants.length > 1;

    if (hasOptions) {
      const swatchesScript = document.getElementById('swatchesData');
      const swatchesData = swatchesScript ? JSON.parse(swatchesScript.textContent) : { colorNameList: '', styleNameList: '', variantNameList: '' };
      const colorNameList = swatchesData.colorNameList?.split(',') || [];
      const styleNameList = swatchesData.styleNameList?.split(',') || [];
      const variantNameList = swatchesData.variantNameList?.split(',') || [];

      
      $(product.options).each((i, option) => {
        const name = option.name;
        const lowerCaseName = name.toLowerCase();
        const isSpecificColorProduct = colorNameList.includes(product.handle); // Based on product handle
        const isSpecificStyleProduct = styleNameList.includes(product.handle); // Based on product handle
        const isSpecificVariantProduct = variantNameList.includes(product.handle); // Based on product handle

        
        const swatchWrapper = $(`<div class="swatch-wrapper" data-index="${option.position}"></div>`);
        let optionValuesClasses = "option-values product-form__input";
        if (isSpecificColorProduct) optionValuesClasses += " color";
        else if (isSpecificStyleProduct) optionValuesClasses += " zodiac sign";
        else if (isSpecificVariantProduct) optionValuesClasses += " specific variant";
        else optionValuesClasses += ` ${lowerCaseName.replace(/\s+/g, '-')}`;

        const optionValues = $(`<div class="${optionValuesClasses}"></div>`);
        swatchWrapper.append(`<div class="viewcolor">${name}</div>`);

        $(option.values).each((valIndex, value) => {
          
          const inputId = `${name.replace(/[^a-zA-Z0-9_-]/g, "")}-${valIndex}`;
          optionValues.append(`<input id="${inputId}" type="radio" value-qv="${value}" name="${name}">`);
          let labelHtml = '';
          if (isSpecificStyleProduct) {
            labelHtml = `<label for="${inputId}" class="custom-selector-style" data-index="${valIndex}">${value}</label>`;
            } else if (isSpecificColorProduct) {


                let imgURLStyle = `background-color:${value};`;

                const baseFilename = value.trim().replace(/\s+/g, '-').replace(/[^\w-]/g, '');
                let swatchBackgroundImageUrl = "";
      
                if (baseFilename) {
                  const urlTemplateFromLiquid = `//metabolaeceyloncinnamon.com/cdn/shop/files/PLACEHOLDER_FILENAME.png?v=167`;
      
                  if (urlTemplateFromLiquid.includes("PLACEHOLDER_FILENAME.png") && "PLACEHOLDER_FILENAME.png" !== '') { // Added check for non-empty placeholder
                      swatchBackgroundImageUrl = urlTemplateFromLiquid.replace("PLACEHOLDER_FILENAME.png", `${baseFilename}.png`).split("?")[0];
                  }
                }
      
                if (swatchBackgroundImageUrl) {
                  imgURLStyle += ` background-image: url('${swatchBackgroundImageUrl}');`;
                }

                labelHtml = `
                  <label variantcolor="${value}" 
                         image-position-quickview="${value}" 
                         for="${inputId}" 
                         class="custom-selector-style-collection2" 
                         data-index="${valIndex}">
                    <span class="filter-color-product-grid" style="${imgURLStyle}"></span>
                  </label>`;
          } else if (isSpecificVariantProduct) {
              let imgURLStyle = `background-color:${value};`;
              let swatchBackgroundImageUrl = "";
          
              const targetOptionKey = `option${option.position}`;
          
              const matchingVariant = product.variants.find(
                  v => v[targetOptionKey] === value && v.featured_image && v.featured_image.src
              );
          
              if (matchingVariant) {
                  swatchBackgroundImageUrl = matchingVariant.featured_image.src;
              }
          
              if (swatchBackgroundImageUrl) {
                  imgURLStyle += ` background-image: url('${swatchBackgroundImageUrl}');`;
                  imgURLStyle += ` background-size: cover; background-position: center;`;
              }
          
              labelHtml = `
                <label variantcolor="${value}"
                       image-position-quickview="${value}"
                       for="${inputId}"
                       class="custom-selector-style-collection2"
                       data-index="${valIndex}">
                  <span class="filter-color-product-grid specific" style="${imgURLStyle}"></span>
                  <span class="variant-name-text">${value}</span>
                </label>`;
          } else {
            const className = (value.length < 3 && !isNaN(parseFloat(value))) ? "square" : "label";
            labelHtml = `<label for="${inputId}" class="${className}" data-index="${valIndex}">${value}</label>`;
          }
          optionValues.append(labelHtml);
        });
        swatchWrapper.append(optionValues.append('<div class="color-variants qv"></div>'));
        $("#qv-variants").append(swatchWrapper);
      });

      let firstVariantToSelect = product.variants.find(v => v.available) || product.variants[0];
      if (firstVariantToSelect) {
        $(firstVariantToSelect.options).each((optIdx, optValue) => {
          if (product.options[optIdx]) {
            $(`#qv-variants input[name="${product.options[optIdx].name}"][value-qv="${optValue}"]`).prop('checked', true);
          }
        });
      }
      fetchAndProcessQuickviewData(handle, commonUICallbackAfterAjax);
    } else {
      if (product.variants.length > 0) updateSingleVariantUI(product.variants[0]);
      else {
        $("#qv-add-to-cart").addClass("sold-out").css("display", "none");
        $("#qv-soldout").css("display", "block");
        $("#qv-customize").css("display", "none");
        $("#qv-price, #qv-compareatprice").html('');
      }
      fetchAndProcessQuickviewData(handle, commonUICallbackAfterAjax);
    }
  }).fail(() => { $('.qv-wrapper').removeClass('loading'); });
}

function loadCurrentQvVariants() {
  currentVariants = {};
  let numOptions = window.myVar?.options?.length || 0;

  $('#qv-variants > div.swatch-wrapper').each(function() {
    const optionPosition = $(this).data('index');
    if (!optionPosition) return;
    const optionKey = `select-option${optionPosition}`;
    const $checkedRadio = $(this).find('input[type="radio"]:checked');
    if ($checkedRadio.length > 0) currentVariants[optionKey] = $checkedRadio.attr('value-qv').trim();
  });

  $('#qv-variants .dropdown-wrapper').each(function() {
    const $select = $(this).find('select.select__select');
    if ($select.length === 0) return;
    const match = $select.attr('id')?.match(/select-option(\d+)/);
    if (!match || !match[1]) return;
    const optionKey = `select-option${match[1]}`;
    if (!currentVariants[optionKey]) currentVariants[optionKey] = $select.val().trim();
  });

  $('#qv-variants input[value-qv]').removeClass('disabled');

  if (numOptions > 0 && window.myVar?.options?.length > 0) {
    const currentOpt1 = currentVariants['select-option1'];
    if (numOptions >= 2 && currentOpt1) {
      const availableOpt2 = new Set();
      $(`#variants-hide-me option[data-image-positions^="${currentOpt1} /"][stock="true"]`).each(function() {
        const parts = $(this).attr('data-image-positions').split(' / ');
        if (parts.length >= 2) availableOpt2.add(parts[1].trim());
      });
      $(`#qv-variants .swatch-wrapper[data-index="2"] input[value-qv]`).each(function() {
        if (!availableOpt2.has($(this).attr('value-qv'))) $(this).addClass('disabled');
      });

      const currentOpt2 = currentVariants['select-option2'];
      if (numOptions >= 3 && currentOpt2) {
        const prefix = `${currentOpt1} / ${currentOpt2}`;
        const availableOpt3 = new Set();
        $(`#variants-hide-me option[data-image-positions^="${prefix} /"][stock="true"]`).each(function() {
          const parts = $(this).attr('data-image-positions').split(' / ');
          if (parts.length >= 3) availableOpt3.add(parts[2].trim());
        });
        $(`#qv-variants .swatch-wrapper[data-index="3"] input[value-qv]`).each(function() {
          if (!availableOpt3.has($(this).attr('value-qv'))) $(this).addClass('disabled');
        });
      }
    } else if (numOptions === 1) {
      const availableOpt1 = new Set();
      $(`#variants-hide-me option[stock="true"]`).each(function() { availableOpt1.add($(this).attr('data-image-positions').trim()); });
      $(`#qv-variants .swatch-wrapper[data-index="1"] input[value-qv]`).each(function() {
        if (!availableOpt1.has($(this).attr('value-qv'))) $(this).addClass('disabled');
      });
    }
  }

  let imagePositionsToShow = [];
  let targetVariantString = "";
  if (numOptions > 0) {
    const parts = [];
    let allOptsSelected = true;
    for (let i = 1; i <= numOptions; i++) {
      if (currentVariants[`select-option${i}`]) parts.push(currentVariants[`select-option${i}`]);
      else { allOptsSelected = false; break; }
    }
    if (allOptsSelected && parts.length > 0) targetVariantString = parts.join(' / ');
  }

  if (targetVariantString) {
    const el = $(`#variants-hide-me option[data-image-positions="${targetVariantString}"]`);
    if (el.length > 0) imagePositionsToShow = el.text()?.split(',').map(p => p.trim()).filter(Boolean) || [];
  }

  if (imagePositionsToShow.length === 0 && currentVariants['select-option1'] && numOptions === 1) {
    const label = $(`#qv-variants label[variantcolor="${currentVariants['select-option1']}"][image-position-quickview]`);
    const posStr = label.attr('image-position-quickview');
    if (label.length > 0 && posStr && !posStr.includes(' / ')) {
      imagePositionsToShow = posStr.split(',').map(p => p.trim()).filter(Boolean);
    }
  }

  $('[id^="image-positionquick-"]').hide();
  const showImages = (positions) => {
    positions.forEach(pos => {
      const img = $(`#image-positionquick-${pos}`);
      if (img.length && img.attr('data-alt') !== 'engrave-front' && img.attr('data-alt') !== 'engrave-back') {
        img.css('display', 'block');
      }
    });
  };

  if (imagePositionsToShow.length > 0) {
    showImages(imagePositionsToShow);
  } else {
    const allImageDivs = $('[id^="image-positionquick-"]');
    const defaultPositions = [];
    allImageDivs.each(function(idx) { defaultPositions.push(String(idx+1))}); // Fallback to show all based on their original index if no specific positions.
                                                                             // This might need adjustment depending on how `id="image-positionquick-X"` are numbered.
                                                                             // A safer fallback is to show ALL non-engrave images:
    allImageDivs.each(function() {
        const $imageDiv = $(this);
        if ($imageDiv.attr('data-alt') !== 'engrave-front' && $imageDiv.attr('data-alt') !== 'engrave-back') {
            $imageDiv.css('display', 'block');
        }
    });
  }

  const slider = document.querySelector('.image-slider-inside.quickview .flickity-slider') || document.querySelector('.image-slider-inside.quickview');
  if (slider) slider.scrollLeft = 0;
}

function updateQvVariantDetails() {
  if (!window.myVar?.variants) return;
  const productOptions = window.myVar.options || [];
  let selectedOptionsArray = [];
  let allOptionsSelected = productOptions.length === 0 || productOptions.every((opt, i) => currentVariants[`select-option${opt.position}`]);

  if (allOptionsSelected) {
    productOptions.forEach(opt => selectedOptionsArray.push(currentVariants[`select-option${opt.position}`]));
  }

  let matchedVariant = null;
  if (allOptionsSelected) {
    if (productOptions.length === 0 && window.myVar.variants.length === 1) {
        matchedVariant = window.myVar.variants[0];
    } else {
        matchedVariant = window.myVar.variants.find(variant =>
            variant.options.length === selectedOptionsArray.length &&
            variant.options.every((optVal, j) => optVal.trim() === selectedOptionsArray[j]?.trim())
        );
    }
  }

  if (matchedVariant) {
    $("#qv-variantid").val(matchedVariant.id);
    if (matchedVariant.compare_at_price && parseFloat(matchedVariant.compare_at_price) > parseFloat(matchedVariant.price)) {
      $("#qv-compareatprice").html(convertToMoney(matchedVariant.compare_at_price));
      $("#qv-price").html(convertToMoney(matchedVariant.price));
    } else {
      $("#qv-compareatprice").html('');
      $("#qv-price").html(convertToMoney(matchedVariant.price));
    }

    const isPersonalized = ProductTags.some(arr => arr.some(tag => typeof tag === 'string' && tag.toLowerCase() === "personalization"));
    if (ProductUrl.length > 0) $(".qv-customize-url:first").attr("href", ProductUrl[0]);

    $("#qv-soldout").css("display", !matchedVariant.available ? "block" : "none");
    $("#qv-customize").css("display", matchedVariant.available && isPersonalized ? "flex" : "none");
    $("#qv-add-to-cart").css("display", matchedVariant.available && !isPersonalized ? "flex" : "none")
                         .toggleClass("sold-out", !matchedVariant.available);
  } else {
    $("#qv-variantid").val('');
    $("#qv-add-to-cart").addClass("sold-out").css("display", "none");
    $("#qv-soldout").css("display", "block");
    $("#qv-customize").css("display", "none");
  }
}

$(document).on("change", "#qv-variants input[type='radio'], #qv-variants .select__select", function() {
  if (typeof loadCurrentQvVariants === 'function') loadCurrentQvVariants();
  if (typeof updateQvVariantDetails === 'function') updateQvVariantDetails();
});

$(document).on("change", ".custom-selector-upsell", function() {
  const nameValue = $(this).attr("name-upsell");
  const id2Value = $(this).attr("id2");
  const addToCartElement = $(`.cart-button[product="${nameValue}"]`);
  if (addToCartElement.length > 0) addToCartElement.attr("atc-id", id2Value);
});

 
$(document).on("click",".swatch-wrapper label",function() {
  var selectorIndex = $(this).parents(".swatch-wrapper").data("index");
  var selector = "#select-option" + selectorIndex  + " option";
  var index = $(this).data("index");
  $(selector).eq(index).prop('selected', true).trigger('change');
});
$(document).on("click",".thumb-item",function(){
  $("#qv-product-cover img").attr("src",$(this).find("img").attr("src"))
});

//QUICKVIEW FUNCTIONS END

$(document).ready(function() {
  $('.image-link').magnificPopup({
        alignTop : true,
                callbacks: {
                open: function(){
                   $('[data-href="#cart-notification"]').attr("imgshow","true");
                },
                close: function (){
                  setTimeout(function(){
                   $('[data-href="#cart-notification"]').attr("imgshow","false");  
                                       }, 100);
                }
            },
    type:'image'});
});

  
//ISHI FUNCTIONS END


var elementToHide = document.querySelector('.alert-nosuccess1');

// Check if the element is found
if (elementToHide) {
  // Add a click event listener to the element
  elementToHide.addEventListener('click', function () {
    // Set the display property to 'none' when clicked
    elementToHide.style.display = 'none';
  });
}


if (window.innerWidth > 768) {
  $('.zoom-in').magnificPopup({
    type: 'image',
    closeOnContentClick: true,
    closeBtnInside: false,
    image: {
      verticalFit: true
    },
    zoom: {
      enabled: true,
      duration: 300 // don't forget to change the duration also in CSS
    }
  });
}



$('.openVideo').magnificPopup({
    type: 'inline',
    midClick: true,
    mainClass: 'mfp-popup popup-1',
    autoFocusLast: false, // Disable auto-focus on the triggering element
    callbacks: {
        open: 
          function () {
            // Copy the content from video-01 to mfp-content
            $('#mfp-content').html($('#video-01').html());

            // Add custom style to the .mfp-close element to hide it
            $('.mfp-close').css('display', 'none');
        },
        beforeClose: function () {
            // Remove the content from mfp-content
            $('#mfp-content').empty();

            // Restore the display property for .mfp-close
            $('.mfp-close').css('display', 'block');
        }
    }
});



  
if (window.innerWidth <= 768) {  
$('.zoom-in').magnificPopup({
  type: 'image',
  autoFocusLast: false, // Disable auto-focus on the triggering element
  mainClass: 'mfp-popup popup-1',
  callbacks: {
    open: function () {
      var $image = this.currItem.img;

      // Get the mfp-content element
      var mfpContent = $('.mfp-content');

      if (mfpContent.length > 0) {
        // Add your code before closing the </div> tag
        mfpContent.append('<div class="mfp-content-pinch"><div class="css-pinchzoom"><p style="color: #000000;margin: 5px 0px 5px 35px;">pinch to zoom<img class="imgzoom" src="data:image/svg+xml;base64,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"></p><button title="Close (Esc)" type="button" class="mfp-close1">×</button></div></div>');
      }

      // Call the setTransform function to initialize the transformation
      const img = document.querySelector('.mfp-img');
      const stage = document.querySelector('.mfp-figure');
      const container = document.querySelector('.mfp-content');
      let mouseX;
      let mouseY;
      let mouseTX;
      let mouseTY;
      let startX = 0;
      let startY = 0;
      let panning = false;
      let isZoomed = false; // Track whether zoomed in
      let isTransitioning = false; // Track whether transitioning to 1:1

      const ts = {
        scale: 1,
        translate: {
          x: 0,
          y: 0
        }
      };

      // Initialize Hammer.js
      const mc = new Hammer(stage);

      // Enable pinch and pan gestures
      mc.get('pinch').set({ enable: true });
      mc.get('pan').set({ direction: Hammer.DIRECTION_ALL });




      
      mc.on('pinchstart', (event) => {

          // Find all elements with the class 'css-pinchzoom'
          const pinchZoomElements = document.querySelectorAll('.css-pinchzoom');
      
          // Loop through each element and replace the text
          pinchZoomElements.forEach((element) => {
            // Replace "pinch to zoom" with "no move around" inside the element's innerHTML
            element.innerHTML = '<p style="color: #000000;margin: 5px 0px 5px 35px;">now move around!<img class="imgzoom-movearound" src="data:image/svg+xml;base64,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"></p><button title="Close (Esc)" type="button" class="mfp-close1">×</button>';
          });
        
        // Store the initial scale when pinch gesture starts
        event.preventDefault();
        ts.initialScale = ts.scale;
      
      });    



      mc.on('pinchmove', (event) => {
        // Handle pinch gesture
        event.preventDefault();
        ts.scale = Math.max(0.1, ts.initialScale * event.scale); // Allow zoom out beyond 1:1
        
        setTransform();
        isZoomed = true; // User is zoomed in
        isTransitioning = false; // Reset the transitioning flag
      });
      

      mc.on('panstart', (event) => {
        // Handle pan gesture start
        event.preventDefault();
        panning = true;
        mouseX = event.center.x;
        mouseY = event.center.y;
        mouseTX = ts.translate.x;
        mouseTY = ts.translate.y;
      });

      mc.on('panmove', (event) => {
        // Handle pan gesture
        event.preventDefault();
        if (!panning) {
          return;
        }

        // Calculate the maximum allowed translation based on image dimensions and scale
        const imageWidth = img.width * ts.scale;
        const imageHeight = img.height * ts.scale;
        const maxX = (imageWidth - stage.clientWidth) / 2;
        const maxY = (imageHeight - stage.clientHeight) / 2;

        // Calculate the new translation
        ts.translate.x = mouseTX + (event.center.x - mouseX);
        ts.translate.y = mouseTY + (event.center.y - mouseY);

        // Limit the translation to stay within image boundaries
        ts.translate.x = Math.max(-maxX, Math.min(maxX, ts.translate.x));
        ts.translate.y = Math.max(-maxY, Math.min(maxY, ts.translate.y));

        setTransform();
      });




      
      // Define a variable to keep track of the previous scale value
      let prevScale = 1;



      
      mc.on('pinchend panend', () => {
        // Handle gesture end
        panning = false;
  
        // Check if the current scale is less than the previous scale (zooming out)
        if (ts.scale < prevScale) {
                // Re-align the image to fit the edges without slowing down panning
                stage.style.transition = 'transform 0.5s ease'; // Disable transition for panning
                setTimeout(() => {
                  stage.style.transition = ''; // Re-enable transition
                }, 500);
            
                const imageWidth = img.width * ts.scale;
                const imageHeight = img.height * ts.scale;
                const maxX = (imageWidth - stage.clientWidth) / 2;
                const maxY = (imageHeight - stage.clientHeight) / 2;
            
                // Calculate the new translation to fit the edges
                ts.translate.x = Math.max(-maxX, Math.min(maxX, ts.translate.x));
                ts.translate.y = Math.max(-maxY, Math.min(maxY, ts.translate.y));
            
                setTransform();
              }
      
        // Update the previous scale value
        prevScale = ts.scale;
      
        if (ts.scale <= 1 && isZoomed && !isTransitioning) {

          // Find all elements with the class 'css-pinchzoom'
          const pinchZoomElements = document.querySelectorAll('.css-pinchzoom');
        
          // Loop through each element and replace the text
          pinchZoomElements.forEach((element) => {

            element.innerHTML = '<p style="color: #000000;margin: 5px 0px 5px 35px;">pinch to zoom<img class="imgzoom" src="data:image/svg+xml;base64,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"></p><button title="Close (Esc)" type="button" class="mfp-close1">×</button>';
          });
          // Transition back to 1:1 with slower duration
          ts.scale = 1;
          ts.translate = { x: 0, y: 0 };
          stage.style.transition = 'transform 0.5s ease'; // Slow down the transition
          setTransform();
          setTimeout(() => {
            stage.style.transition = ''; // Remove the transition after it completes
            isTransitioning = false;
          }, 500);
          isZoomed = false;
          isTransitioning = true;
        }
      });
    

      function setTransform() {
        const steps = `translate(${ts.translate.x}px,${ts.translate.y}px) scale(${ts.scale}) translate3d(0,0,0)`;
        stage.style.transform = steps;
        }
      }
    }
  });
}
